<template>
  <!-- Fila única para la información del ingreso -->
  <v-row
    no-gutters
    align="center"
    justify="center"
    class="deltia-card ml-2 mr-2 mb-4 pl-7 pr-7"
  >
    <!-- Columna para la información -->
    <v-col cols="12" md="11" class="pt-5 pb-5">
      <!-- Fila para la información -->
      <v-row no-gutters align="center" justify="center">
        <!-- Columna para el monto -->
        <v-col cols="12" md="1" class="hidden-md-and-up">
          <p class="font-weight-medium text--disabled mb-0">Monto</p>
        </v-col>
        <!-- Columna para el importe en pantallas pequeñas-->
        <v-col class="hidden-md-and-up" cols="12">
          <p class="content--text font-weight-medium mb-1">
            ${{ amount | formatNumber }}
          </p>
        </v-col>
        <!-- Columna para la sucursal -->
        <v-col cols="12" md="4" class="hidden-md-and-up">
          <p class="font-weight-medium text--disabled mb-0">Sucursal</p>
        </v-col>
        <!-- Columna para la sucursal en pantallas pequeñas -->
        <v-col class="hidden-md-and-up" cols="12">
          <p class="content--text font-weight-medium mb-1">
            {{ branch.name ? branch.name : "Sin sucursal" }}
          </p>
        </v-col>
        <!-- Columna para el usuario -->
        <v-col cols="12" md="3" class="hidden-md-and-up">
          <p class="font-weight-medium text--disabled mb-0">Usuario</p>
        </v-col>
        <!-- Columna para la fecha para pantallas pequeñas -->
        <v-col class="hidden-md-and-up" cols="12">
          <p class="content--text font-weight-medium mb-1">
            {{ user.name }}
          </p>
        </v-col>
        <!-- Columna para la fecha -->
        <v-col cols="12" md="3" class="hidden-md-and-up">
          <p class="font-weight-medium text--disabled mb-0">Crado</p>
        </v-col>
        <!-- Columna para la fecha para pantallas pequeñas -->
        <v-col class="hidden-md-and-up" cols="12">
          <p class="content--text font-weight-medium mb-1">
            {{ formatDate(date) }}
          </p>
        </v-col>
        <!-- Columna para descripción de un ingreso -->
        <v-col cols="12" md="3" class="hidden-md-and-up">
          <p class="font-weight-medium text--disabled mb-0">Descripción</p>
        </v-col>
        <!-- Columna para descripción de un ingreso en pantallas pequeñas-->
        <v-col class="hidden-md-and-up pb-3" cols="12">
          <p class="content--text font-weight-medium mb-1">
            {{ description }}
          </p>
        </v-col>
        <!-- -----------------------------------------------------------------------------  -->
        <!-- A partir de aquí comienzan los elementos para pantallas medianas y más grandes -->
        <!-- ------------------------------------------------------------------------------ -->
        <v-col cols="12" md="12">
          <v-row>
            <!-- Columna para el importe -->
            <v-col
              class="hidden-sm-and-down pl-0 pb-0 pt-0 ml-0"
              cols="12"
              md="2"
            >
              <v-col cols="12" class="pt-0 pb-0">
                <p class="font-weight-medium text--disabled mb-0">Monto</p>
              </v-col>
              <v-col cols="12" class="pt-0 pb-0">
                <p class="content--text font-weight-medium mb-0">
                  ${{ amount | formatNumber }}
                </p>
              </v-col>
            </v-col>
            <!-- Columna para la sucursal -->
            <v-col
              class="hidden-sm-and-down pl-0 pb-0 pt-0 ml-0"
              cols="12"
              md="3"
            >
              <v-col cols="12" class="pt-0 pb-0">
                <p class="font-weight-medium text--disabled mb-0">Sucursal</p>
              </v-col>
              <v-col cols="12" class="pt-0 pb-0">
                <p class="content--text font-weight-medium mb-0">
                  {{ branch.name ? branch.name : "Sin sucursal" }}
                </p>
              </v-col>
            </v-col>
            <!-- Columna para el usuario -->
            <v-col
              class="hidden-sm-and-down pl-0 pb-0 pt-0 ml-0"
              cols="12"
              md="4"
            >
              <v-col cols="12" class="pt-0 pb-0">
                <p class="font-weight-medium text--disabled mb-0">Usuario</p>
              </v-col>
              <v-col cols="12" class="pt-0 pb-0">
                <p class="content--text font-weight-medium mb-0">
                  {{ user.name }}
                </p>
              </v-col>
            </v-col>
            <!-- Columna para la fecha -->
            <v-col
              class="hidden-sm-and-down pl-0 pb-0 pt-0 ml-0"
              cols="12"
              md="3"
            >
              <v-col cols="12" class="pt-0 pb-0">
                <p class="font-weight-medium text--disabled mb-0">Fecha</p>
              </v-col>
              <v-col cols="12" class="pt-0 pb-0">
                <p class="content--text font-weight-medium mb-0">
                  {{ formatDate(date) }}
                </p>
              </v-col>
            </v-col>
            <!-- Columna para la descripción -->
            <v-col
              class="hidden-sm-and-down mt-3 pl-0 pb-0 pt-0 ml-0"
              cols="12"
              md="12"
            >
              <v-col cols="12" class="pt-0 pb-0">
                <p class="font-weight-medium text--disabled mb-0">
                  Descripción
                </p>
              </v-col>
              <v-col cols="12" class="pt-0 pb-0">
                <p class="content--text font-weight-medium mb-0">
                  {{ description }}
                </p>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <!-- Columna para los ajustes (en pantallas grandes)-->
    <v-col
      class="hidden-sm-and-down"
      cols="12"
      md="1"
      align="right"
      justify="center"
    >
      <!-- Ajustes para actualizar o eliminar -->
      <v-menu top v-model="menu">
        <template v-slot:activator="{ on: menu }">
          <v-btn icon dark v-on="menu" color="primary">
            <v-icon>mdi-cog-outline</v-icon>
          </v-btn>
        </template>
        <!-- Menú para actualizar un usuario -->
        <v-list>
          <!-- Modal para actualizar un usuario -->
          <DeleteIncome
            :movementId="movementId"
            @income-deleted="onIncomeDeleted"
            @income-error="onIncomeError"
          />
        </v-list>
      </v-menu>
    </v-col>
    <!-- Columna para los ajustes (en pantallas pequeñas)-->
    <v-col
      class="hidden-md-and-up"
      cols="12"
      md="1"
      align="center"
      justify="center"
    >
      <!-- Ajustes para actualizar o eliminar -->
      <v-menu top v-model="secondMenu">
        <template v-slot:activator="{ on: secondMenu }">
          <v-btn text v-on="secondMenu" class="red--text font-weight-bold mb-2">
            Eliminar
          </v-btn>
        </template>
        <!-- Menú para actualizar un usuario -->
        <v-list>
          <!-- Modal para actualizar un usuario -->
          <DeleteIncome
            :movementId="movementId"
            @income-deleted="onIncomeDeleted"
            @income-error="onIncomeError"
          />
        </v-list>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
// importamos servicios
import BranchesServices from "@/services/BranchesServices";
import UsersServices from "@/services/UsersServices";

// Importar componentes
const DeleteIncome = () => import("@/components/movements/modals/DeleteIncome");

// Importar mixins
import dateFormat from "@/mixins/dateFormat.js";

// Importar filtros
import { formatNumber } from "@/filters/numeral";

export default {
  name: "IncomeItem",
  filters: { formatNumber },
  mixins: [dateFormat],
  data() {
    return {
      dialog: false,
      menu: false,
      secondMenu: false,
      branch: "",
      user: {}
    };
  },
  components: {
    DeleteIncome
  },
  created: async function() {
    try {
      // Obtenemos el nombre de la sucursal
      if (this.branchId) {
        this.branch = await BranchesServices.getBranch(this.branchId);
      }

      // Obtener usuario que registró el ingreso
      this.user = await UsersServices.getEmployeeById(this.userId);
    } catch (err) {
      // Lanzar un nuevo error
      this.onIncomeError(err.message);
    }
  },
  methods: {
    onIncomeDeleted() {
      this.$emit("income-deleted");
    },
    onIncomeError(errorMessage) {
      this.$emit("income-error", errorMessage);
    }
  },
  props: {
    date: {
      type: String
    },
    branchId: {
      type: String
    },
    amount: {
      type: Number
    },
    movementId: {
      type: String
    },
    description: {
      type: String
    },
    userId: {
      type: String
    }
  }
};
</script>
